// Full-document render of the stearns UtilityPage: PageSkeleton (the React
// document shell) wrapping the utility body.
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { toolboxComponentsMap } from "../blocks/toolboxComponentsMap";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed with
// mutable reactivated props (see PageSkeleton). The body StreamField accepts
// both.
export const Template = (
    props: templates.UtilityPageTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            sidebarNav={props.sidebar_nav}
            sidebarOffersCount={props.offers_count}
        >
            {props.page.body ? (
                <StreamField
                    tagName={React.Fragment}
                    value={props.page.body.value}
                    components={toolboxComponentsMap}
                />
            ) : null}
        </PageSkeleton>
    );
};
